import {Input} from "@/components/ui/input";
import {useFormContext} from "react-hook-form";
import {ComponentProps, useState} from "react";
import {Button} from "@/components/ui/button";
import {Eye, EyeOff} from "lucide-react";
import {LabelField, LabelFieldProps} from "@/components/form/LabelField";


export type TextFieldProps = Omit<ComponentProps<typeof Input>, 'type'> & LabelFieldProps

export function PasswordField({label, name, containerClassName, hideError, ...props}: TextFieldProps) {
    const form = useFormContext()
    const [showPassword, setShowPassword] = useState(false)
    return (
        <LabelField label={label} name={name} containerClassName={containerClassName} hideError={hideError}>
            <div className="relative">
                <LabelField label={false} name={name} hideError>
                    <Input
                        id={name}
                        {...form.register(name)}
                        type={showPassword ? "text" : "password"}
                        {...props}
                    />
                </LabelField>
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                    onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <EyeOff className="h-4 w-4"/> : <Eye className="h-4 w-4"/>}
                </Button>
            </div>
        </LabelField>
    )
}

PasswordField.displayName = "PasswordField";
